import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  Avatar,
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DeleteIllnessAttestationDialog } from "./DeleteIllnessAttestationDialog";
import { DateIsXMeasurementOld } from "../../functions/dates";

export function TransferHistory({ history, onMeldungClicked, reloadHistory, hideSearchbar = false, program }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteAttestationDialog, setDeleteAttestationDialog] = useState(false);
  const [currentIllnessAttestation, setCurrentIllnessAttestation] = useState(null);

  const meldungFuerUserId = useMemo(() => {
    if (searchParams && searchParams.get("userId")) {
      return searchParams.get("userId");
    } else {
      return null;
    }
  }, [searchParams]);

  useEffect(() => {
    const searchQueryParam = searchParams.get("query");
    if (searchQueryParam) {
      setSearchQuery(searchQueryParam);
    }
  }, [searchParams]);

  let filteredKeys = [];
  if (history.allKeysByDate && history.allKeysByDate.length > 0) {
    if (searchQuery) {
      filteredKeys = history.allKeysByDate.filter((key) => history.byKey[key].artText.toLowerCase().includes(searchQuery.toLowerCase()));
    } else {
      filteredKeys = [...history.allKeysByDate];
    }
  }

  useEffect(() => {
    if (currentIllnessAttestation) setDeleteAttestationDialog(true);
  }, [currentIllnessAttestation]);

  const renderListItem = (meldung) => {
    const offerDeletion = DateIsXMeasurementOld(meldung.gemeldetAm, "YYYYMMDD", "days") <= 7;

    return (
      <>
        <ListItemAvatar>
          <Avatar>{meldung.artTextKurz}</Avatar>
        </ListItemAvatar>
        <ListItemText primary={`${meldung.artText} ${t("vom")} ${meldung.gemeldetAmText}`} secondary={meldungsZeitraum(meldung)} />
        {offerDeletion &&
          program === "SENDAU" && ( //not available unless the employee created the Illness Attestation themselves
            <IconButton onClick={() => setCurrentIllnessAttestation(meldung)} sx={{ ml: 1 }}>
              <DeleteIcon />
            </IconButton>
          )}
      </>
    );
  };

  const meldungsZeitraum = (meldung) => {
    if (!meldung) {
      return "";
    } else {
      return meldung.art === "03" ? meldung.vdatText + " - " + meldung.vzeitText + " - " + meldung.bzeitText : meldung.vdatText + " - " + meldung.bdatText;
    }
  };
  const handleAlleAnzeigenChange = () => {
    if (program === "SNDAUM") {
      navigate("/SNDAUM/SENDAU/HISTORIE?userId=" + meldungFuerUserId);
    } else {
      navigate("/SENDAU/HISTORIE");
    }
  };

  return (
    <>
      <DeleteIllnessAttestationDialog
        reloadHistory={reloadHistory}
        open={deleteAttestationDialog}
        setOpen={setDeleteAttestationDialog}
        currentIllnessAttestation={currentIllnessAttestation}
        setCurrentIllnessAttestation={setCurrentIllnessAttestation}
        meldungsZeitraum={meldungsZeitraum}
      />
      <Box p={1}>
        <Typography align="left" variant="h5">
          {t("Gemeldete Arbeitsunfähigkeiten")}
        </Typography>
      </Box>
      {!hideSearchbar && (
        <Box pl={2} pr={2} pt={1} pb={1}>
          <TextField
            variant="outlined"
            label={t("Suche")}
            value={searchQuery}
            onChange={(event) => {
              setSearchQuery(event.target.value);
            }}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}
      <List>
        {filteredKeys &&
          filteredKeys.length > 0 &&
          filteredKeys.map((id) => (
            <ListItem key={id} disablePadding={!!onMeldungClicked}>
              {onMeldungClicked && <ListItemButton onClick={() => onMeldungClicked(history.byKey[id])}>{renderListItem(history.byKey[id])}</ListItemButton>}
              {!onMeldungClicked && renderListItem(history.byKey[id])}
            </ListItem>
          ))}
        {(!filteredKeys || filteredKeys.length == 0) && !searchQuery && (
          <Box p={1}>
            <Typography align="left" variant="body2">
              {t("Es wurden noch keine Arbeitsunfähigkeiten gemeldet.")}
            </Typography>
          </Box>
        )}
        {(!filteredKeys || filteredKeys.length == 0) && searchQuery && (
          <Box p={1}>
            <Typography align="left" variant="body2">
              {t("Es wurden keine Meldungen für den Suchbegriff gefunden.")}
            </Typography>
          </Box>
        )}
      </List>
      {history.weitereVorhanden && (
        <Button color="primary" onClick={handleAlleAnzeigenChange}>
          {t("Alle anzeigen")}
        </Button>
      )}
    </>
  );
}
